import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom';
import { notification, Button, Typography, Drawer, Row, Space } from 'antd';
import { useQuery } from 'react-query';
import moment from 'moment';
import DF from 'DisplayFramework';
import { toCurrency } from 'utils/utils';
import DataGrid from 'components/DataGrid';
import ButtonComponent from 'components/Button';
import RouterLink from 'components/RouterLink';
import ParListSelect from 'components/ParListSelect';
import ProductInput from './PropDetail/ProductInput';
// import OfferInput from './PropDetail/OfferInput';
import OfferInput from 'pages/Configuration/Management/ParametersFiltering/OfferInput';
import TasksListPopover from '../workflow/TasksListPopover';
import { DataGridProps, DataGridColDef } from 'components/DataGrid/DataGrid';
import { PlusOutlined } from '@ant-design/icons';
import {
  ProposalListResponse,
  findPropByAnyRefOrStatusOrDate,
  FindPropByAnyRefOrStatusOrDateParams,
} from 'services/proposal';
import {
  FinCTListResponse,
  findFinCTByAnyRefOrStatusOrDate,
} from 'services/fincontract';
import GetLabel from 'DisplayFramework/components/GetLabel';
import SynthesList from 'pages/Configuration/ParSynthesObject/SynthesList';
import IActions from 'icons/IActions';
import ProposalSelect from 'components/ProposalSelect';
import ModalControllerNV from 'components/ModalControllerNV';
import ProposalModal from './ProposalModal';
import { CopyTwoTone, LayoutTwoTone } from '@ant-design/icons';
import { isNil } from 'lodash';

type PropListProps = RouteComponentProps & {
  onSelect?: (item: ProposalListResponse) => void;
  hideExtraAction?: boolean;
  hideFilters?: boolean;
  phase?: string;
  mfid?: number;
  tpauthid?: number;
  tpauthdetailid?: number;
  search?: boolean;
  prcode?: string;
  PropOrProd?: string;
  refetch?: boolean;
  hideAction?: boolean;
  clientname?: string;
  setdelet?: any;
  delet?: boolean;
  flagPropWithCtreference?: boolean;
  ctstatus?: string;
} & Pick<DataGridProps<any>, 'rowSelection'>;

const PropList = (props: PropListProps) => {
  const search = props.location.search;
  const params = new URLSearchParams(search);

  const phase = params.get('phase');

  const lphase = phase ?? props?.PropOrProd ?? 'PROPOSAL';
  const { onSelect, rowSelection } = props;

  const initialSearchParams: FindPropByAnyRefOrStatusOrDateParams = {
    branchid: '' as any,
    mfid: props.mfid ?? 0,
    tpauthdetailid: props.tpauthdetailid ?? 0,
    tpauthid: props.tpauthid ?? 0,
    brokername: '',
    clientname: props.clientname ?? '',
    ctphase: props.phase ?? '',
    ctreference: '',
    ctstatus: props.ctstatus ?? '',
    datemax: '',
    datemin: '',
    marketingid: '' as any,
    network: '',
    offerid: '' as any,
    prcode: props.prcode ?? '',
    propreference: '',
    tpidbroker:localStorage.getItem('userrole')==="BROKER"?Number(localStorage.getItem('tpid')) :"" as any,
    tprefbroker:'',
    tpreference: '',
    flagPropWithCtreference: props.flagPropWithCtreference ?? false,
    tpidclient: 0,
  };
  const history = useHistory();
  const [searchs, setsearchs] = useState<any>(false);
  const [searchParams, setSearchParams] =
    useState<FindPropByAnyRefOrStatusOrDateParams>({
      ...initialSearchParams,
    });

  const [visible, setVisible] = useState(false);

  const [ctrid, setctrid] = useState<number>();
  const [prcode, setprcode] = useState<string>();
  const [currcode, setcurrcode] = useState<string>();
  const closeSynthes = () => {
    setVisible(false);
  };
  const openDrawerSynthes = (ctrid: number, currcode: string) => {
    setctrid(ctrid);
    setVisible(true);
    setcurrcode(currcode);
  };
  const useContracts = (searchParams: any, ctPhase: string) => {
    const proposalQuery = useQuery(
      ['findPropByAnyRefOrStatusOrDate', searchParams, props.tpauthid],
      () =>
        findPropByAnyRefOrStatusOrDate({
          ...searchParams,
          tpauthid: props.tpauthid ?? 0,
        })
          .then((res) => res.list)
          .catch((error) => {
            notification.error({
              description: error.message,
              message: 'Proposal Service is not available',
            });
            return [];
          }),
      {
        enabled: lphase === 'PROPOSAL' && !isNil(props.search),
        staleTime: 60 * 1000,
      }
    );

    const fincontractQuery = useQuery(
      ['findFinCTByAnyRefOrStatusOrDate', searchParams],
      () =>
        findFinCTByAnyRefOrStatusOrDate(searchParams).then((res) => res.list),
      { enabled: lphase === 'PROD' && !isNil(props.search) }
    );

    return lphase === 'PROPOSAL' ? proposalQuery : fincontractQuery;
  };

  const {
    data: dataSource,
    isFetching,
    refetch,
  } = useContracts(searchParams, lphase);

  useEffect(() => {
    if (props.refetch) refetch();
    if (dataSource && dataSource?.length === 0) {
      props.setdelet(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.refetch, props.setdelet, props.delet, dataSource]);

  const columns: DataGridColDef<
    FinCTListResponse | ProposalListResponse | any
  >[] = [
    {
      dataIndex: 'propreference',
      render: (propreference, record) => {
        if (onSelect) {
          return (
            <Typography.Link onClick={() => onSelect(record)}>
              {propreference}
            </Typography.Link>
          );
        } else if (props.search && props.mfid)
          return (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {propreference}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <ProposalModal
                  ctrid={Number(record.ctrid ?? null)}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title="Master Facility"
                />
              )}
            />
          );
        else
          return (
            <RouterLink
              to={`/proposal/${record.ctrid}?phase=${lphase}`}
              prevent={props.hideExtraAction}
            >
              {propreference}
            </RouterLink>
          );
      },
      filtrable: true,
      fixed: 'left',
      width: 120,
    },
    {
      dataIndex: 'ctreference',
      render: (ctreference, record) => {
        if (onSelect) {
          return (
            <Typography.Link onClick={() => onSelect(record)}>
              {ctreference}
            </Typography.Link>
          );
        } else
          return (
            <RouterLink to={`/proposal/${record.ctrid}?phase=PROD`}>
              {ctreference}
            </RouterLink>
          );
      },
      filtrable: true,
      fixed: 'left',
      width: 120,
    },

    {
      dataIndex: 'prcode',
      width: 190,
      ellipsis: true,
      filtrable: true,
      filterComponent: (
        <ProductInput
          style={{ width: '100%' }}
          onSelected={(value) => {
            setprcode(value);
          }}
        />
      ),
      render: (value, record) => record.prcodelabel,
    },
    {
      comcode: 'offeridlabel',
      dataIndex: 'offerid',
      width: 190,
      ellipsis: true,
      filtrable: true,
      filterComponent: (
        // <OfferInput
        //   params={{
        //     prcode: prcode,
        //     filters: '',
        //     finamount: 0,
        //     duration: 0,
        //     catalogid: 0,
        //     searchMode: 'PRCODE',
        //   }}
        //   style={{ width: '100%' }}
        // />
        <OfferInput
          params={{
            prcode: String(prcode),
            mgid: Number(localStorage.getItem('mgid')),
          }}
          allData
        />
      ),
      render: (value, record) => record.offeridlabel,
    },
    {
      dataIndex: 'clientname',
      filtrable: true,
      width: 190,
      ellipsis: true,
    },
    {
      dataIndex: 'ctcomment',
      filtrable: false,
      width: 130,
      ellipsis: true,
    },

    /*{
        dataIndex: 'tprefbroker',
        filtrable: true,
        width: 200,
      },
      {
        dataIndex: 'tpreference',
        filtrable: true,
        width: 200,
      },*/
    {
      dataIndex: 'ctfinancedamount',
      width: 150,
      render: (value, record) =>
        toCurrency(
          value,
          record.currcode ?? localStorage.getItem('currcode') ?? ''
        ),
    },

    {
      dataIndex: 'mfusedamount',
      width: 150,
      render: (value, record) =>
        toCurrency(
          value,
          record.currcode ?? localStorage.getItem('currcode') ?? ''
        ),
    },
    {
      dataIndex: 'mfbookedamount',
      width: 150,
      render: (value, record) =>
        toCurrency(
          value,
          record.currcode ?? localStorage.getItem('currcode') ?? ''
        ),
    },

    {
      dataIndex: 'mfavailableamount',
      width: 150,
      render: (value, record) =>
        toCurrency(
          value,
          record.currcode ?? localStorage.getItem('currcode') ?? ''
        ),
    },

    {
      dataIndex: 'ctstatusdate',
      width: 120,
      render: (ctstatusdate) => moment(ctstatusdate).format('DD-MM-YYYY'),
    },
    {
      comcode: 'mfreference',
      dataIndex: 'mfid',
      filtrable: true,
      filterComponent: <ProposalSelect prcode="MASTER" onlyctrid />,
      width: 150,
      render: (mfreference, record) => {
        return (
          <RouterLink to={`/proposal/${record.mfid}?phase=PROPOSAL`}>
            {record.mfreference}
          </RouterLink>
        );
      },
    },
    {
      comcode: 'ctnetworkcode',
      dataIndex: 'network',
      filtrable: 'network',
      filterComponent: <ParListSelect parcode="CHANNEL" />,
      render: (value, record) => record.ctnetworkcodelabel,
      width: 80,
    },
    {
      comcode: 'statuslabel',
      dataIndex: 'ctstatus',
      width: 190,
      ellipsis: true,
      fixed: 'right',
      filtrable: true,
      filterComponent: (
        <ParListSelect
          parcode={lphase === 'PROD' ? 'CTSTATUS' : 'PROPSTATUS'}
          style={{ width: '100%' }}
        />
      ),
      render: (value, record) =>
        ['RESCHEDULE', 'TRANSFERCT'].includes(record.ctfinmodevent)
          ? record.statuslabel + ' - ' + record.ctfinmodeventlabel
          : record.statuslabel,
    },
    {
      key: 'synthes',
      width: 75,
      comcode: 'synthes',
      fixed: 'right',
      render: (text, record) => (
        <Button
          //type="primary"
          size="middle"
          icon={<LayoutTwoTone twoToneColor="#eb2f96" />}
          onClick={() => openDrawerSynthes(record.ctrid, record.currcode)}
        ></Button>
      ),
    },
    {
      key: 'copy',
      comcode: 'copy',
      fixed: 'right',
      width: 75,
      render: (_, record) => (
        <Space direction="vertical" size="small">
          {lphase === 'PROPOSAL' && record.mfid === null && (
            <Row>
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <Button
                    icon={<CopyTwoTone twoToneColor="#52c41a" />}
                    size="middle"
                    onClick={() => {
                      setVisible(true);
                    }}
                  ></Button>
                )}
                modal={({ setVisible, visible }) => (
                  <ProposalModal
                    ctrid={Number(record.ctrid ?? null)}
                    copy
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    onSuccess={() => setVisible(false)}
                    title={<GetLabel label="CopyProposal" />}
                  />
                )}
              />
            </Row>
          )}
        </Space>
      ),
    },
    {
      key: 'actions',
      comcode: 'actions',
      fixed: 'right',
      width: 100,
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Row>
            <TasksListPopover
              entityId={record.ctrid}
              tpid={record.tpidclient}
              entityReference={
                lphase === 'PROPOSAL'
                  ? record.propreference
                  : record.ctreference
              }
              entityName={lphase === 'PROD' ? 'CONTRACT' : 'PROPOSAL'}
              requestedamount={record.ctfinancedamount}
              currcode={record.currcode}
              title={
                lphase === 'PROD'
                  ? record.ctreference + ' - ' + record.clientname
                  : record.propreference + ' - ' + record.clientname
              }
              clientName={record.clientname}
              onSuccess={refetch}
              prcode={record.prcode}
            >
              <Button
                icon={<IActions height="15px" width="15px" />}
                size="middle"
              >
                <GetLabel label="actions" />
              </Button>
            </TasksListPopover>
          </Row>
        </Space>
      ),
    },
  ];

  const filterColumns = () => {
    if (props.hideFilters) {
      return columns.filter(
        (e) => e.key !== 'synthes' && e.key !== 'actions' && e.key !== 'copy'
      );
    } else if (props?.PropOrProd === 'PROD') {
      return columns.filter(
        (e) =>
          e.key !== 'synthes' &&
          e.key !== 'actions' &&
          e.dataIndex !== 'propreference' &&
          e.key !== 'copy'
      );
    } else if (props.flagPropWithCtreference) {
      return columns.filter(
        (e) =>
          e.dataIndex !== 'propreference' &&
          e.key !== 'synthes' &&
          e.key !== 'actions' &&
          e.key !== 'copy' &&
          e.dataIndex !== 'propreference'
      );
    } else {
      return columns;
    }
  };

  return (
    <DF.Provider pagcode="proplist">
      <DataGrid
        titleComcode={lphase === 'PROD' ? 'pageTitleProd' : 'pageTitleProposal'}
        scroll={{ x: 2000, y: 500 }}
        dataSource={dataSource}
        rowKey={(record) => record.ctrid}
        columns={filterColumns()}
        onSearch={(values) => {
          /*  if (lphase === 'PROD') {
            setissearchPROD(true);
            setissearchPROPOSAL(false);
          } else {
            setissearchPROPOSAL(true);
            setissearchPROD(false);
          }*/
          setSearchParams({ 
            ...values,
            ctstatus: props.ctstatus ?? values.ctstatus
          });
          setsearchs(true);
          refetch();
        }}
        componentName="proposal_list"
        initialSearchValues={initialSearchParams}
        isLoading={isFetching}
        rowSelection={rowSelection}
        extractData="ProposalList"
        hideExtraAction={props.hideExtraAction}
        extraActions={
          <ButtonComponent
            onClick={() => history.push('/proposal/create')}
            icon={<PlusOutlined />}
            type="primary"
            comcode="header.btnnew"
          />
        }
        hideFilters={props.hideFilters}
      />
      <Drawer
        title={<GetLabel label="synthesliste" />}
        width={400}
        onClose={closeSynthes}
        visible={visible}
        destroyOnClose
        headerStyle={{ backgroundColor: '#00a896' }}
        bodyStyle={{ paddingBottom: 80, alignContent: 'center' }}
        style={{
          //position: 'absolute',
          right: '0px',
          bottom: '0px',
          width: '100%',
          padding: '10px 16px',
          //textAlign: 'right',
          //background: '#fff',
          //borderTop: '1px solid #e9e9e9',
        }}
      >
        <SynthesList
          objecttype="PROPOSAL"
          objectid={ctrid || 0}
          currcode={currcode ?? ''}
        />
      </Drawer>
    </DF.Provider>
  );
};

export default withRouter(PropList);
